import React from 'react';

const Toggle = ({ checked = false, onChange, disabled = false, className = '' }) => {
  return (
    <button
      type="button"
      onClick={() => !disabled && onChange && onChange(!checked)}
      disabled={disabled}
      className={`relative inline-flex h-[22px] w-[40px] items-center rounded-full transition-colors focus:outline-none ${
        checked ? 'bg-[#40c191]' : 'bg-gray-300'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
      role="switch"
      aria-checked={checked}
      aria-disabled={disabled}
    >
      <span
        className={`inline-block h-[18px] w-[18px] transform rounded-full bg-white shadow-sm transition-transform ${
          checked ? 'translate-x-[19px]' : 'translate-x-[2px]'
        }`}
      />
    </button>
  );
};

export default Toggle;

